import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const RouteWithSubroutes = ({ component: Component, routes, ...otherProps }) => (
  <Route
    {...otherProps}
    render={props => <Component {...props} routes={routes} />}
  />
);

RouteWithSubroutes.propTypes = {
  component: PropTypes.func.isRequired,
  routes: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string,
  })),
};

RouteWithSubroutes.defaultProps = {
  routes: undefined,
};

export default RouteWithSubroutes;
